import React, { useState } from 'react';
import GuilanPreview from '../assets/images/GuilanPreview.jpg';
import { ReactComponent as Magnifier } from "../assets/icons/Minimalistic Magnifer.svg";
import { useNavigate } from 'react-router-dom';

interface HeroProps {
  onAdventureClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onAdventureClick }) => {
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (loading) return;

    const trimmedSearchText = searchText.trim();
    if (!trimmedSearchText) return;

    setLoading(true);
    try {
      navigate(`/search-results?q=${encodeURIComponent(trimmedSearchText)}`);
    } catch (error) {
      console.error('Navigation failed:', error);
    } finally {
      // استفاده از setTimeout برای اطمینان از اتمام navigation
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleMagnifierClick = () => {
    handleSearch();
  };

  return (
    <div className="relative h-[270px] w-full tablet:h-[693px] desktop:h-[693px]">
      {/* Hero Image */}
      <img
        src={GuilanPreview}
        alt="لوتکا"
        className="w-full h-full object-cover"
        loading="eager"
        fetchPriority="high"
      />

      {/* Overlay */}
      {/* Search Bar Container */}
      <div className="absolute inset-0 flex flex-col justify-center items-center gap-4 px-4">
        {/* Title */}
        <h1 className="text-white text-center font-myYekanMedium">
          <span className="block desktop:text-[32px] tablet:text-[32px] text-[18px] ">لوتکا</span>
          <span className="block desktop:text-[24px] tablet:text-[24px] text-[18px]">اولین پلتفرم بومی سفر به گیلان</span>
        </h1>

        {/* Search bar — desktop & tablet only, centered in hero */}
        <div className="hidden tablet:flex relative desktop:w-[600px] tablet:w-[460px]">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyPress}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            placeholder="جستجوی جاذبه‌های دیدنی، رستوران و اقامتگاه"
            dir="rtl"
            className="w-full h-12 font-myYekanRegular text-[#222222] text-[14px] pr-5 pl-12 rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-50"
            style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.12), 0 0 0 0.5px rgba(0,0,0,0.06)' }}
            disabled={loading}
          />
          <button
            onClick={handleMagnifierClick}
            disabled={loading}
            className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center p-1.5 rounded-full hover:bg-gray-100 transition-colors disabled:opacity-50"
            aria-label="جستجو"
          >
            <Magnifier className="w-5 h-5 text-gray-500" />
          </button>
        </div>
      </div>

      {/* Mobile search bar — floats over hero bottom edge */}
      <div className="tablet:hidden absolute bottom-0 left-0 right-0 translate-y-[22px] flex justify-center px-4 z-10">
        <div className="relative w-full max-w-[360px]">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyPress}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            placeholder="جستجوی جاذبه‌ها، رستوران و اقامتگاه"
            dir="rtl"
            className="w-full h-11 font-myYekanRegular text-[#222] text-[13px] pr-4 pl-[72px] rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-50"
style={{ boxShadow: '0 1px 6px rgba(0,0,0,0.06), 0 0 0 0.5px rgba(0,0,0,0.04)' }}
            disabled={loading}
          />
          <button
            onClick={handleMagnifierClick}
            disabled={loading}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="جستجو"
          >
            <Magnifier className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
